import { Form, Input, Radio } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import type DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';
import {
  DOCUMENT_ROLE_LABELS,
  DOCUMENT_ROLE_ORDER,
  DocumentRole,
} from 'types/Roles';

import { ModalForm, type SubmitCallback } from '../../ModalForm';

export interface AddMemberModalProps {
  isVisible?: boolean;
  onClose?: () => void;
  parentDocument: DocumentWithMembershipStore;
}

function AddMemberModal({
  isVisible,
  onClose,
  parentDocument,
}: AddMemberModalProps) {
  const handleFormSubmit: SubmitCallback = async (values) => {
    console.info('AddMemberModal#handleFormSubmit %O', values);
    const existingUser = parentDocument.members.getByEmail(values.email);
    if (existingUser) {
      throw new Error(
        `A user with the email address ${values.email} already exists`
      );
    }
    await parentDocument.members.addMember(values.email, values.role);
  };

  return (
    <ModalForm
      formName="AddMemberModalForm"
      okText="Add User"
      onClose={onClose}
      onSubmit={handleFormSubmit}
      open={isVisible}
      title="Add User"
    >
      <Form.Item
        label="User Email"
        name="email"
        rules={[{ required: true }, { type: 'email' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="role"
        initialValue={DocumentRole.VIEW}
        rules={[{ required: true }]}
      >
        <Radio.Group>
          {DOCUMENT_ROLE_ORDER.map((role) => (
            <Radio key={role} value={role}>
              {DOCUMENT_ROLE_LABELS[role]}
            </Radio>
          ))}
        </Radio.Group>
      </Form.Item>
    </ModalForm>
  );
}

export default observer(AddMemberModal);
